var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Trash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-trash",
    d: "M12.5,4A2.784,2.784,0,0,0,9.768,6.4h-2.7a.525.525,0,0,0-.19,0H5.592a.6.6,0,0,0,0,1.2h.844L7.43,18.012A2.19,2.19,0,0,0,9.591,20h5.817a2.19,2.19,0,0,0,2.161-1.988L18.563,7.6h.844a.6.6,0,0,0,0-1.2H18.122a.584.584,0,0,0-.19,0h-2.7A2.784,2.784,0,0,0,12.5,4Zm0,1.2a1.568,1.568,0,0,1,1.524,1.2H10.976A1.568,1.568,0,0,1,12.5,5.2ZM7.625,7.6h9.749L16.39,17.9a.984.984,0,0,1-.982.9H9.591a.985.985,0,0,1-.982-.9Zm3.484,1.991a.6.6,0,0,0-.583.609v6a.592.592,0,1,0,1.184,0v-6a.6.6,0,0,0-.174-.433A.588.588,0,0,0,11.109,9.591Zm2.763,0a.6.6,0,0,0-.583.609v6a.592.592,0,1,0,1.184,0v-6a.6.6,0,0,0-.174-.433A.588.588,0,0,0,13.872,9.591Z",
    transform: "translate(-5 -4)",
    fill: "#ff4d4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Trash);
export default __webpack_public_path__ + "static/media/icons8-trash_.0202a974c6a2d85d8f3dd7320f81aae9.svg";
export { ForwardRef as ReactComponent };